export const DEFAULT_COURSE_TITLE = 'Course Title';
export const SUPER_USER_ID = 1;
export const MAIN_COMMUNITY_CHANNEL_ID = 1;
export const USER_PERSISTED_KEY = 'user-persisted';
export const DEAL_EXPLORER_FILTERS_KEY = 'deal-explorer-filters';
export const isProd = import.meta.env.VITE_MODE === 'production';
export const isDevelopmentOrTesting = ['development', 'testing'].includes(
	import.meta.env.VITE_MODE,
);
